import { render } from "./UpcomingEventsFullCalendar.vue?vue&type=template&id=259c7034"
import script from "./UpcomingEventsFullCalendar.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsFullCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__